import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import image from '../img/bg5.jpg';
import Grid from '@material-ui/core/Grid';
import { ProfileCardHeader } from '../components/ProfileCard/ProfileCardHeader';
import { CardBody } from '../components/Card/CardBody';
import { CardFooter } from '../components/Card/CardFooter';
import { Card } from '../components/Card/Card';
import Typography from '@material-ui/core/Typography';
import GraphicEqIcon from '@material-ui/icons/GraphicEq';
import FastForwardIcon from '@material-ui/icons/FastForward';
import { AuthContext } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faFacebook, faInstagramSquare } from '@fortawesome/free-brands-svg-icons';
import Footer from '../core/Layout/Footer';
import Fade from '@material-ui/core/Fade';
import { CardHeader } from '../components/Card/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import { db } from '../firebase';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Form, FormDate, FormInput, FormSelect } from '../core/Formikfy';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { Education } from '../components/Tile/Education';
import { Container } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import { Experience } from '../components/Tile/Experience';
import { Activity } from '../components/Tile/Activity';
import { useParams } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50vh',
    width: '100%',
    color: 'white',
  },
  profileCardGridItem: {
    marginTop: '200px',
  },
  name: {
    color: '#3C4858',
    fontFamily: `"Roboto Slab", "Times New Roman", serif`,
    margin: '10px auto',
    fontWeight: 700,
    letterSpacing: '0.05em',
  },
  position: {
    margin: '20px auto ',
    fontSize: '1rem',
    fontWeight: 700,
    color: '#3C4858',
  },
  function: {
    textTransform: 'uppercase',
    margin: '0 auto 20px',
    fontSize: '1rem',
    fontWeight: 400,
    color: '#3C4858',
  },
  description: {
    color: '#999',
    margin: '1.071rem auto 0',
    fontSize: '1rem',
    fontWeight: 400,
  },
  socialContainer: {
    padding: '10px 0',
  },
  facebook: {
    margin: '0 1rem',
    transition: 'transform 250ms',
    display: 'inline-block',
    color: '#4968ad',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  instagram: {
    margin: '0 1rem',
    transition: 'transform 250ms',
    display: 'inline-block',
    color: '#CC2685',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  linkedin: {
    margin: '0 1rem',
    transition: 'transform 250ms',
    display: 'inline-block',
    color: '#0A65C0',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  avatar: {
    margin: '10px 0 10px auto',
    color: theme.palette.secondary.main,
    backgroundColor: 'white',
    alignItems: 'left',
  },
  gridItem: {
    margin: '30px auto',
  },
  subCardHeader: {
    textAlign: 'left',
    color: 'white',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    marginLeft: '20px',
  },
  subCardHeaderGrid: {
    margin: 'auto 0',
  },
  contentHeading: {
    textAlign: 'left',
    margin: '20px auto 0',
    fontSize: '1rem',
    fontWeight: 700,
    color: '#3C4858',
  },
  contentSubHeading: {
    textAlign: 'left',
    textTransform: 'uppercase',
    margin: '0 auto 20px',
    fontSize: '0.75rem',
    fontWeight: 400,
    color: '#999',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formInput: {
    margin: '10px',
  },
}));

export const Profile = () => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const [isPublicView, setIsPublicView] = useState(false);
  const [profileInfo, setProfileInfo] = useState<any>();
  const { id } = useParams();
  const [educationInfoOpen, setEducationInfoOpen] = useState(false);
  const [checked, setChecked] = useState(true);
  const [basicInfoOpen, setBasicInfoOpen] = React.useState(false);
  const [activityInfoOpen, setActivityInfoOpen] = React.useState(false);
  const [experienceInfoOpen, setExperienceInfoOpen] = React.useState(false);
  const CHARACTER_LIMIT = 2000;
  const [position, setPosition] = useState('');

  useEffect(() => {
    const profile = async () => {
      const docID = id || currentUser.uid;
      const info = await db.collection('profile').doc(docID).get();
      if (id && id !== currentUser.uid) {
        setIsPublicView(true);
      }
      setProfileInfo(info.data());
      console.log(info.data());
      setPosition(info.data().current_position);
      return info.data();
    };

    profile().then();
  }, []);

  const educationUpdate = async (index, newEducation) => {
    const data = [...profileInfo.qualifications];
    data[index] = { activity: newEducation };
    try {
      await db.collection('profile').doc(currentUser.uid).update({ qualifications: data });
      setProfileInfo({ ...profileInfo, qualifications: data });
    } catch (e) {
      console.error(e);
    }
  };
  const deleteEducation = async (qualificationIndex) => {
    console.log(qualificationIndex);
    const data = [...profileInfo.qualifications];
    const newData = data.filter((qualification, index) => index !== qualificationIndex);
    try {
      await db.collection('profile').doc(currentUser.uid).update({ qualifications: newData });
      setProfileInfo({ ...profileInfo, qualifications: newData });
    } catch (e) {
      console.error(e);
    }
  };
  const experienceUpdate = async (index, newData) => {
    const data = [...profileInfo.experiences];
    if (index !== -1) {
      data[index] = newData;
    } else {
      data.push(newData);
    }
    try {
      await db.collection('profile').doc(currentUser.uid).update({ experiences: data });
      setProfileInfo({ ...profileInfo, experiences: data });
    } catch (e) {
      console.error(e);
    }
  };
  const deleteExperience = async (experienceIndex) => {
    const data = [...profileInfo.experiences];
    const newData = data.filter((experience, index) => index !== experienceIndex);
    try {
      await db.collection('profile').doc(currentUser.uid).update({ experiences: newData });
      setProfileInfo({ ...profileInfo, experiences: newData });
    } catch (e) {
      console.error(e);
    }
  };
  const activityUpdate = async (index, newActivity) => {
    const data = [...profileInfo.activities];
    data[index] = { activity: newActivity };
    try {
      await db.collection('profile').doc(currentUser.uid).update({ activities: data });
      setProfileInfo({ ...profileInfo, activities: data });
    } catch (e) {
      console.error(e);
    }
  };
  const deleteActivity = async (activityIndex) => {
    const data = [...profileInfo.activities];
    const newData = data.filter((activity, index) => index !== activityIndex);
    try {
      await db.collection('profile').doc(currentUser.uid).update({ activities: newData });
      setProfileInfo({ ...profileInfo, activities: newData });
    } catch (e) {
      console.error(e);
    }
  };

  if (!profileInfo) {
    return <div></div>;
  }
  return (
    <Grid container component="main" className={classes.container}>
      <Container>
        <Grid container style={{ justifyContent: 'center' }}>
          {/*Profile Basic Info*/}
          <Grid item xs={12} sm={11} className={classes.profileCardGridItem}>
            <Card style={{ padding: '0 20px', position: 'relative' }} elevation={2}>
              <ProfileCardHeader isPublicView={isPublicView} src={profileInfo.dp_url} />
              {!isPublicView && (
                <IconButton
                  style={{ right: '10px', top: '10px', position: 'absolute' }}
                  color="primary"
                  onClick={() => setBasicInfoOpen(true)}
                >
                  <EditIcon />
                </IconButton>
              )}
              <Dialog
                open={basicInfoOpen}
                onClose={() => setBasicInfoOpen(false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">Update Profile</DialogTitle>
                <Form
                  className={classes.form}
                  initialValues={{
                    firstName: profileInfo.firstName,
                    lastName: profileInfo.lastName,
                    description: profileInfo.description,
                    facebook: profileInfo.facebook,
                    instagram: profileInfo.instagram,
                    linkedIn: profileInfo.instagram,
                    position: position,
                    function: profileInfo.function,
                  }}
                  onSubmit={async (data) => {
                    try {
                      const updatedProfileInfo = data;
                      updatedProfileInfo.current_position = position;
                      const response = await db
                        .collection('profile')
                        .doc(currentUser.uid)
                        .update({
                          description: data.description || '',
                          firstName: data.firstName || '',
                          lastName: data.lastName || '',
                          facebook: data.facebook || '',
                          instagram: data.instagram || '',
                          linkedIn: data.instagram || '',
                          current_position: position || '',
                          function: data.function || '',
                        });
                      setProfileInfo({ ...profileInfo, ...updatedProfileInfo });
                    } catch (e) {
                      console.error(e);
                    }
                  }}
                >
                  <DialogContent>
                    <DialogContentText>
                      Enter your information to display them in your Profile
                    </DialogContentText>
                    <FormInput
                      className={classes.formInput}
                      type="text"
                      label="First Name"
                      name="firstName"
                      variant="standard"
                      fullWidth={true}
                    />
                    <FormInput
                      className={classes.formInput}
                      type="text"
                      label="Last Name"
                      name="lastName"
                      variant="standard"
                      fullWidth={true}
                    />
                    <FormInput
                      className={classes.formInput}
                      type="url"
                      label="Facebook Profile Link"
                      name="facebook"
                      variant="standard"
                      fullWidth={true}
                    />
                    <FormInput
                      className={classes.formInput}
                      type="url"
                      label="Instagram Profile Link"
                      name="instagram"
                      variant="standard"
                      fullWidth={true}
                    />
                    <FormInput
                      className={classes.formInput}
                      type="url"
                      label="LinkedIn Profile Link"
                      name="linkedIn"
                      variant="standard"
                      fullWidth={true}
                    />
                    {profileInfo.positions.length !== 0 && (
                      <div
                        style={{
                          margin: '10px 0 10px 10px',
                        }}
                      >
                        <FormSelect
                          type="text"
                          label="Position"
                          name="position"
                          value={position}
                          onChange={(event) => setPosition(event.target.value)}
                          variant="standard"
                          fullWidth={true}
                        >
                          {profileInfo.positions.map((position) => (
                            <MenuItem value={`${position.position} - ${position.name}`}>
                              {position.position} - {position.name}
                            </MenuItem>
                          ))}
                        </FormSelect>
                      </div>
                    )}
                    <FormInput
                      className={classes.formInput}
                      type="text"
                      label="Function"
                      name="function"
                      variant="standard"
                      fullWidth={true}
                    />
                    <FormInput
                      className={classes.formInput}
                      type="text"
                      label="Description"
                      name="description"
                      variant="standard"
                      inputProps={{
                        maxlength: CHARACTER_LIMIT,
                      }}
                      multiline={true}
                      fullWidth={true}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setBasicInfoOpen(false)} color="primary">
                      Cancel
                    </Button>
                    <Button type="submit" onClick={() => setBasicInfoOpen(false)} color="primary">
                      Update
                    </Button>
                  </DialogActions>
                </Form>
              </Dialog>
              <CardBody style={{ padding: '16px 0px' }}>
                <Typography variant="h5" className={classes.name}>
                  {profileInfo.firstName} {profileInfo.lastName}
                </Typography>
                <div className={classes.socialContainer}>
                  <a href={profileInfo.facebook} className={classes.facebook}>
                    <FontAwesomeIcon icon={faFacebook} size="2x" />
                  </a>
                  <a href={profileInfo.instagram} className={classes.instagram}>
                    <FontAwesomeIcon icon={faInstagramSquare} size="2x" />
                  </a>
                  <a href={profileInfo.linkedin} className={classes.linkedin}>
                    <FontAwesomeIcon icon={faLinkedin} size="2x" />
                  </a>
                </div>
                <Typography variant="h6" className={classes.position}>
                  {profileInfo.current_position}
                </Typography>
                <Typography variant="h6" className={classes.function}>
                  {profileInfo.function}
                </Typography>
                <Typography variant="h6" className={classes.description}>
                  {profileInfo.description}
                </Typography>
              </CardBody>
            </Card>
          </Grid>

          {/*Education Info*/}
          <Grid item xs={12} sm={10} md={5} lg={5} className={classes.gridItem}>
            <Fade in={checked}>
              <Card elevation={2}>
                <CardHeader>
                  <Grid container>
                    <Grid item xs={2}>
                      <Avatar className={classes.avatar}>
                        <GraphicEqIcon fontSize="small" />
                      </Avatar>
                    </Grid>
                    <Grid item xs={9} className={classes.subCardHeaderGrid}>
                      <Typography variant="h6" className={classes.subCardHeader}>
                        Education
                      </Typography>
                    </Grid>
                    {!isPublicView && (
                      <Grid item xs={1} style={{ justifyContent: 'center', display: 'flex' }}>
                        <IconButton
                          style={{ color: 'white' }}
                          onClick={() => setEducationInfoOpen(true)}
                        >
                          <AddIcon />
                        </IconButton>
                      </Grid>
                    )}
                    <Dialog open={educationInfoOpen} onClose={() => setEducationInfoOpen(false)}>
                      <DialogTitle>Update Qualification</DialogTitle>
                      <Form
                        className={classes.form}
                        initialValues={{
                          title: '',
                          yearFrom: Date.now(),
                          yearTo: Date.now(),
                        }}
                        onSubmit={async (data) => {
                          const newData = {
                            title: data.title,
                            yearFrom: data.yearFrom,
                            yearTo: data.yearTo,
                          };
                          const qualifications = [...profileInfo.qualifications];
                          qualifications.push(newData);
                          await db
                            .collection('profile')
                            .doc(currentUser.uid)
                            .update({ qualifications: qualifications });
                          setProfileInfo({ ...profileInfo, qualifications: qualifications });
                          setEducationInfoOpen(false);
                        }}
                      >
                        <DialogContent>
                          <DialogContentText>
                            Enter your qualifications to display them in your Profile
                          </DialogContentText>

                          <div>
                            <Card elevation={3} style={{ marginTop: '20px' }}>
                              <CardContent>
                                <FormInput
                                  type="text"
                                  label="Title"
                                  name="title"
                                  variant="standard"
                                  fullWidth={true}
                                  // onChange={e => handleInputChange(e, i)}
                                />
                                <Grid container>
                                  <Grid item xs={6} style={{ paddingRight: '10px' }}>
                                    <FormDate
                                      label="From"
                                      name="yearFrom"
                                      variant="standard"
                                      fullWidth={true}
                                    />
                                  </Grid>
                                  <Grid item xs={6} style={{ paddingLeft: '10px' }}>
                                    <FormDate
                                      label="To"
                                      name="yearTo"
                                      variant="standard"
                                      fullWidth={true}
                                    />
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </div>
                        </DialogContent>
                        <DialogActions style={{ display: 'block' }}>
                          <Button
                            onClick={() => setEducationInfoOpen(false)}
                            color="primary"
                            style={{ marginLeft: '10px' }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            color="primary"
                            style={{ marginRight: '10px', float: 'right' }}
                          >
                            Add
                          </Button>
                        </DialogActions>
                      </Form>
                    </Dialog>
                  </Grid>
                </CardHeader>
                <CardBody style={{ marginTop: '20px' }}>
                  {profileInfo.qualifications.map((qualification, index) => (
                    <Education
                      itemList={profileInfo.qualifications}
                      item={qualification}
                      tileId={index}
                      educationUpdate={educationUpdate}
                      deleteEducation={deleteEducation}
                      isPublicView={isPublicView}
                    />
                  ))}
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Fade>
          </Grid>

          {/*Experience Info*/}
          <Grid item xs={12} sm={10} md={5} lg={5} className={classes.gridItem}>
            <Fade in={checked}>
              <Card elevation={2}>
                <CardHeader>
                  <Grid container>
                    <Grid item xs={2}>
                      <Avatar className={classes.avatar}>
                        <GraphicEqIcon fontSize="small" />
                      </Avatar>
                    </Grid>
                    <Grid item xs={9} className={classes.subCardHeaderGrid}>
                      <Typography variant="h6" className={classes.subCardHeader}>
                        Experience
                      </Typography>
                    </Grid>
                    {!isPublicView && (
                      <Grid item xs={1} style={{ justifyContent: 'center', display: 'flex' }}>
                        <IconButton
                          style={{ color: 'white' }}
                          onClick={() => setExperienceInfoOpen(true)}
                        >
                          <AddIcon />
                        </IconButton>
                      </Grid>
                    )}
                    <Dialog open={experienceInfoOpen} onClose={() => setExperienceInfoOpen(false)}>
                      <DialogTitle>Update Experience</DialogTitle>
                      <Form
                        className={classes.form}
                        initialValues={{
                          place: '',
                          position: '',
                        }}
                        onSubmit={async (data) => {
                          const newData = {
                            place: data.place,
                            position: data.position,
                          };
                          const experiences = [...profileInfo.experiences];
                          experiences.push(newData);
                          await db
                            .collection('profile')
                            .doc(currentUser.uid)
                            .update({ experiences: experiences });
                          setProfileInfo({ ...profileInfo, experiences: experiences });
                          setExperienceInfoOpen(false);
                        }}
                      >
                        <DialogContent>
                          <DialogContentText>
                            Enter your experience to display them in your Profile
                          </DialogContentText>

                          <div>
                            <Card elevation={3} style={{ marginTop: '20px' }}>
                              <CardContent>
                                <FormInput
                                  type="text"
                                  label="Function"
                                  name="place"
                                  variant="standard"
                                  fullWidth={true}
                                  // onChange={e => handleInputChange(e, i)}
                                />
                                <FormInput
                                  type="text"
                                  label="Position"
                                  name="position"
                                  variant="standard"
                                  fullWidth={true}
                                  // onChange={e => handleInputChange(e, i)}
                                />
                              </CardContent>
                            </Card>
                          </div>
                        </DialogContent>
                        <DialogActions style={{ display: 'block' }}>
                          <Button
                            onClick={() => setExperienceInfoOpen(false)}
                            color="primary"
                            style={{ marginLeft: '10px' }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            color="primary"
                            style={{ marginRight: '10px', float: 'right' }}
                          >
                            Add
                          </Button>
                        </DialogActions>
                      </Form>
                    </Dialog>
                  </Grid>
                </CardHeader>
                <CardBody style={{ marginTop: '20px' }}>
                  {profileInfo.experiences.map((experience, index) => (
                    <Experience
                      itemList={profileInfo.experiences}
                      item={experience}
                      tileId={index}
                      experienceUpdate={experienceUpdate}
                      deleteExperience={deleteExperience}
                      isPublicView={isPublicView}
                    />
                  ))}
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Fade>
          </Grid>

          {/*Activities Info*/}
          <Grid item xs={12} sm={10} md={5} lg={5} className={classes.gridItem}>
            <Fade in={checked}>
              <Card elevation={2}>
                <CardHeader>
                  <Grid container>
                    <Grid item xs={2}>
                      <Avatar className={classes.avatar}>
                        <GraphicEqIcon fontSize="small" />
                      </Avatar>
                    </Grid>
                    <Grid item xs={9} className={classes.subCardHeaderGrid}>
                      <Typography variant="h6" className={classes.subCardHeader}>
                        Activities
                      </Typography>
                    </Grid>
                    {!isPublicView && (
                      <Grid item xs={1} style={{ justifyContent: 'center', display: 'flex' }}>
                        <IconButton
                          style={{ color: 'white' }}
                          onClick={() => setActivityInfoOpen(true)}
                        >
                          <AddIcon />
                        </IconButton>
                      </Grid>
                    )}
                    <Dialog open={activityInfoOpen} onClose={() => setActivityInfoOpen(false)}>
                      <DialogTitle>Update Activity</DialogTitle>
                      <Form
                        className={classes.form}
                        initialValues={{
                          activity: '',
                          // to: new Date(props.item.yearTo.seconds * 1000).toDateString(),
                        }}
                        onSubmit={async (data) => {
                          const newData = {
                            activity: data.activity,
                          };
                          const activities = [...profileInfo.activities];
                          activities.push(newData);
                          await db
                            .collection('profile')
                            .doc(currentUser.uid)
                            .update({ activities: activities });
                          setProfileInfo({ ...profileInfo, activities: activities });
                          setActivityInfoOpen(false);
                        }}
                      >
                        <DialogContent>
                          <DialogContentText>
                            Enter your activity to display them in your Profile
                          </DialogContentText>
                          <div>
                            <Card elevation={3} style={{ marginTop: '20px' }}>
                              <CardContent>
                                <FormInput
                                  type="text"
                                  label="Activity"
                                  name="activity"
                                  variant="standard"
                                  fullWidth={true}
                                  // onChange={e => handleInputChange(e, i)}
                                />
                                {/*{inputList.length !== 1 && <Button size="small" onClick={() => handleRemoveClick(i)} style={{float: "right", marginTop: "10px"}}><DeleteIcon color="action"/></Button>}*/}
                              </CardContent>
                            </Card>
                            {/*{inputList.length - 1 === i && <Button size="small" onClick={handleAddClick} style={{float: "right", margin: "10px"}}><AddCircleOutlineIcon color="secondary" fontSize='large' /></Button>}*/}
                          </div>
                        </DialogContent>
                        <DialogActions style={{ display: 'block' }}>
                          <Button
                            onClick={() => setActivityInfoOpen(false)}
                            color="primary"
                            style={{ marginLeft: '10px' }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            color="primary"
                            style={{ marginRight: '10px', float: 'right' }}
                          >
                            Add
                          </Button>
                        </DialogActions>
                      </Form>
                    </Dialog>
                  </Grid>
                </CardHeader>
                <CardBody style={{ marginTop: '20px' }}>
                  {profileInfo.activities.map((activity, index) => (
                    <Activity
                      itemList={profileInfo.experiences}
                      item={activity}
                      tileId={index}
                      activityUpdate={activityUpdate}
                      deleteActivity={deleteActivity}
                      isPublicView={isPublicView}
                    />
                  ))}
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Fade>
          </Grid>

          {/*Contribution Info*/}
          <Grid item xs={12} sm={10} md={5} lg={5} className={classes.gridItem}>
            <Fade in={checked}>
              <Card elevation={2}>
                <CardHeader>
                  <Grid container>
                    <Grid item lg={2}>
                      <Avatar className={classes.avatar}>
                        <FastForwardIcon fontSize="small" />
                      </Avatar>
                    </Grid>
                    <Grid item lg={9} className={classes.subCardHeaderGrid}>
                      <Typography variant="h6" className={classes.subCardHeader}>
                        Contribution
                      </Typography>
                    </Grid>
                  </Grid>
                </CardHeader>
                <CardBody>
                  <Typography variant="h6" className={classes.contentHeading}></Typography>
                  <Typography variant="h6" className={classes.contentSubHeading}>
                    {}
                  </Typography>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Fade>
          </Grid>
        </Grid>
      </Container>
      <Grid item lg={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};
